module.exports = __webpack_public_path__ + "static/SM3-704b0e180748fcb13248498559834bb8.png";